function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "uuid-b72da6c3-b743-4868-8566-0d5b8722b6e0",
  clipPath: "url(#clip0_397_4254)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M2.966 5.02702H5.39C5.688 5.02702 5.931 4.78402 5.931 4.48502C5.931 4.18602 5.688 3.94402 5.39 3.94402H2.966C1.331 3.94402 0 5.27402 0 6.90902C0 8.54402 1.33 9.87401 2.966 9.87401H5.39C5.688 9.87401 5.931 9.63101 5.931 9.33202C5.931 9.03302 5.688 8.79002 5.39 8.79002H2.966C1.928 8.79002 1.084 7.94602 1.084 6.90902C1.084 5.87202 1.929 5.02702 2.966 5.02702Z",
  fill: "#95A1B2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M5.26491 10.782C5.13891 10.707 4.99391 10.688 4.85191 10.727C4.71391 10.766 4.59691 10.857 4.51991 10.984L3.75591 12.33C3.61091 12.592 3.69991 12.918 3.95991 13.072C4.04291 13.119 4.12891 13.14 4.22991 13.14C4.42891 13.14 4.60991 13.036 4.70291 12.869L5.46691 11.523C5.61291 11.26 5.52391 10.934 5.26391 10.781L5.26491 10.782Z",
  fill: "#95A1B2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M4.51982 2.83202C4.61282 2.99902 4.79482 3.10302 4.99382 3.10302C5.06182 3.10302 5.16382 3.09102 5.26482 3.03602C5.52482 2.89102 5.61582 2.55702 5.46782 2.29202L4.70382 0.949019C4.63582 0.826019 4.52282 0.737019 4.38382 0.697019C4.24282 0.657019 4.08882 0.674019 3.95982 0.745019C3.69982 0.890019 3.60882 1.22302 3.75582 1.48902L4.51982 2.83202Z",
  fill: "#95A1B2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  d: "M8.74206 3.03301L8.74606 3.03501C8.82906 3.08101 8.91406 3.10201 9.01606 3.10201C9.21506 3.10201 9.39606 2.99801 9.48906 2.83101L10.2541 1.48701C10.4001 1.22401 10.3111 0.898013 10.0511 0.744013C9.92606 0.669013 9.78006 0.650013 9.63806 0.690013C9.49906 0.728013 9.38206 0.820013 9.30606 0.947013L8.54306 2.29001C8.39706 2.55201 8.48506 2.87701 8.74306 3.03201L8.74206 3.03301Z",
  fill: "#95A1B2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_5",
  d: "M11.0353 3.94302H8.61134C8.31234 3.94302 8.06934 4.18602 8.06934 4.48402C8.06934 4.78202 8.31234 5.02602 8.61134 5.02602H11.0353C12.0733 5.02602 12.9173 5.87002 12.9173 6.90802C12.9173 7.94602 12.0723 8.78902 11.0353 8.78902H8.61134C8.31234 8.78902 8.06934 9.03202 8.06934 9.33102C8.06934 9.63002 8.31234 9.87302 8.61134 9.87302H11.0353C12.6703 9.87302 14.0003 8.54302 14.0003 6.90802C14.0003 5.27302 12.6703 3.94302 11.0353 3.94302Z",
  fill: "#95A1B2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_6",
  d: "M9.47996 10.985C9.41196 10.862 9.29896 10.773 9.16096 10.733C9.01696 10.696 8.86296 10.711 8.73696 10.783C8.47796 10.926 8.38596 11.26 8.53296 11.526L9.29596 12.868C9.38896 13.036 9.57096 13.14 9.76996 13.14C9.83696 13.14 9.93796 13.128 10.04 13.072C10.166 13.003 10.257 12.886 10.295 12.744C10.332 12.602 10.314 12.455 10.243 12.328L9.47996 10.985Z",
  fill: "#95A1B2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_7",
  d: "M7.00389 1.52588e-05C6.70589 1.52588e-05 6.46289 0.243015 6.46289 0.542015V2.56202C6.46289 2.86002 6.70589 3.10302 7.00389 3.10302C7.30189 3.10302 7.54589 2.86002 7.54589 2.56202V0.542015C7.54589 0.243015 7.30289 1.52588e-05 7.00389 1.52588e-05Z",
  fill: "#95A1B2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_8",
  d: "M7.00389 10.704C6.70589 10.704 6.46289 10.947 6.46289 11.246V13.266C6.46289 13.565 6.70589 13.808 7.00389 13.808C7.30189 13.808 7.54589 13.565 7.54589 13.266V11.246C7.54589 10.947 7.30289 10.704 7.00389 10.704Z",
  fill: "#95A1B2"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_397_4254"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 13.808,
  fill: "white"
})));

var SvgDisconnect = function SvgDisconnect(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDisconnect, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/disconnect.3a7581d7.svg";
export { ForwardRef as ReactComponent };